import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { Alert, Box, Button, CardActions, Checkbox, Modal, Paper, Snackbar, Stack, Step, StepLabel, Stepper, Tab, Table, TableHead, Tabs } from "@mui/material";
import { DialogContent } from "@mui/material";
import { TextField, Typography, IconButton } from "@mui/material";
import { TableBody, TableRow, TableContainer } from "@mui/material";
import { CardContent, CardHeader } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import EditIcon from "@mui/icons-material/Edit";
import dayjs, { Dayjs } from "dayjs";
import { BarraDeFerramentas } from "../../Components/barra-de-ferramentas/BarraDeFerramentas";
import DocsUploadIB from "../../Components/Upload/DocsUploadIB";
import HomeViewTecnico from "../../Styles/layout/homeViewTecnico";
import { del, get, post, post_file } from "../../Services/tokenConfig";
import Historico from "../Historico/historico";
import LoadingVulpesSmall from "../../Styles/Loader/loadingSmall";
import { CustomTextField, CustomThemeProvider } from "../../Styles/theme/customThemeprovider";
import { AuthContext } from "../../AuthContext/AuthContext";
import {
  StyledTableCellCabecalho,
  StyledTableCellWithoutBorder, StyledTableHeadWithoutBorder,
} from "../../Styles/tabelCellStyled/customTableCell";
import { func_print } from "../../Func_genericas/func_print";
import { handler_pesquisa } from "../../Func_genericas/func_pesquisa";
import { Search } from "@mui/icons-material";
import { ICaderno } from "../../Interfaces/cadernos/caderno1";
import { cores, mensagem_tem_a_certeza_de_apagar_alteracoes, operacao_erro, operacao_sucesso } from "../../Func_genericas/valores_estaticos";
import { DialogNovoCadernoManual } from "./dialog_novo_caderno_manual";
import { IBeneficiarios, IParcela } from "../../Interfaces/beneficiarios/beneficiario";
import { DialogNovaEficienciaAlimentar } from "../EficAlimentar/1-IdentificbenefExp/dialog_novo_eficiencia_alimentar";
import { aviso_sem_info } from "../../Func_genericas/aviso_sem_info";
import LoadingVulpes from "../../Styles/Loader/loading";
import { PatternFormat } from "react-number-format";
import PhoneInput from "react-phone-number-input";
import { isValidEmail } from "../../Func_genericas/isValidEmail";
import { verify_nif } from "../../Func_genericas/verify_nif";
import ConfirmDialog from "../../Components/CustomDialog/customdialog";
import { loader } from "../../Func_genericas/loader";
import { ISubparcela } from "../../Interfaces/cadernos/caderno2";
import { ButtonCadernos } from "../../Components/barra-de-ferramentas/ButtonCadernos";
import { DialogReplicarCadernoDeAnoAnterior } from "./dialog_replicar_caderno_de_ano_anterior";
import DocsUploadIE from "../../Components/Upload/DocsUploadIE";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(2),
    },
    label: {
      display: "flex",
      flexWrap: "wrap",
      "& > *": {
        // margin: theme.spacing(1),
        // width: theme.spacing(16),
        // height: theme.spacing(16),
        // minWidth: 325,
      },
    },
    header: {
      textAlign: "center",
      background: "#FAFAFA",
      color: "#7e2706",
    },
    picker: {
      color: "#7e2706",
      "&.Mui-checked": {
        color: "#ccafa3",
      },
    },
    tabs: {
      "& .MuiTabs-indicator": {
        backgroundColor: cores.cor1,
        height: 3,
      },
      "& .MuiTab-root.Mui-selected": {
        color: cores.cor1,
      },
    },
  })
);

function Home() {
  const classes = useStyles();
  const navigate = useNavigate();
  const auth = useContext(AuthContext);
  const [hover, setHover] = useState({ flag: false, id: 0 });
  const [isloading, setIsLoading] = useState(true);

  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);
  const [message, setMessage] = useState("");

  const [file, setFile] = useState<any>(); // Para carregar ficheiros IE e candidaturas

  const [openInfoAboutBeneficiario, setOpenInfoAboutBeneficiario] = React.useState(false); //ativa popup info beneficiario
  // const [openEditBenef, setOpenEditBenef] = React.useState(false); //ativa popup para editar o beneficiario
  const [uploadIE, setuploadIE] = React.useState(false); //ativa popup do upload
  const [uploadIE_from_parcelas, setuploadIE_from_parcelas] = React.useState(false); //ativa popup do upload
  const [flag_gerir_caderno, setflag_gerir_caderno] = useState(false);
  const [flag_escolha_caderno_manual, setflag_escolha_caderno_manual] = useState(false);
  const [flag_escolha_carregar_candidatura, setflag_escolha_carregar_candidatura] = useState(false);

  const [lista_benefeciario, set_lista_benefeciario] = useState<IBeneficiarios[]>([]);
  const [lista_cadernos_ativos, set_lista_cadernos_ativos] = useState<ICaderno[]>([]);

  const [beneficiario, set_beneficiario] = useState<IBeneficiarios>();
  const [string_para_pesquisar,] = useState<string>();
  const [lista_benefeciario_pesquisa, set_lista_benefeciario_pesquisa] = useState<IBeneficiarios[]>([]);
  const [, set_obj_template_escolhido] = useState<any>();
  const [obj_caderno, set_obj_caderno] = useState<ICaderno>();

  const [listaParcelas, setlistaParcelas] = useState<IParcela[]>([]);
  const [listaParcelas_a_eliminar, setlistaParcelas_a_eliminar] = useState<IParcela[]>([]);
  const [parcela_para_ver_subparcelas, set_parcela_para_ver_subparcelas] = useState<IParcela>();
  const [drapChoose, setDrapChoose] = useState<string>("Norte");

  const [valueYear, setValueYear] = React.useState<Dayjs | null>(dayjs);
  const [,set_id_caderno_a_replicar] = React.useState<string>('');
  const [id_rosto_a_replicar, set_id_rosto_a_replicar] = React.useState<string>('');
  const [ano_novo_caderno, set_ano_novo_caderno] = React.useState<Dayjs | null>(dayjs);

  const [valueTab, setValueTab] = React.useState("1"); // TAB NAVIGATION - Escolher Parcelas / histórico

  const [flag_gerir_eficiencia, setflag_gerir_eficiencia] = useState(false);
  // const [id_agri_eficiencia] = useState(0)
  const [id_agri_eficiencia, set_id_agri_eficiencia] = useState(0)

  const [telemovel, setTelemovel] = useState<string>('');
  const [nome, set_nome] = useState<string>('');
  const [nif, set_nif] = useState<string>('');
  const [nifap, set_nifap] = useState<string>('');
  const [telefone, setTelefone] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [morada, setMorada] = useState<string>('');
  const [Concelho, setConcelho] = useState<string>('');
  const [freguesia, setFreguesia] = useState<string>('');
  const [Codigo_postal, setCodigo_postal] = useState<string>('');
  const [disabled, setDisabled] = useState<boolean>(false);

  const [error_email, set_error_email] = useState<boolean>(false);
  const [error_nif, set_error_nif] = useState<boolean>(false);

  const [open_modal_criar_benef, set_open_modal_criar_benef] = useState<boolean>(false);
  const [flag_editado, set_flag_editado] = React.useState<boolean>(false);

  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState<boolean>(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes_aux, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_aux] = React.useState<boolean>(false);
  const [open_modal_criar_parcela, set_open_modal_criar_parcela] = React.useState<boolean>(false);


  const [n_parcelario, set_n_parcelario] = useState<string>('');
  const [n_sequencia, set_n_sequencia] = useState<string>('');
  const [nome_parcela, set_nome_parcela] = useState<string>('');
  const [area_parcela, set_area_parcela] = useState<string>('');
  const [iqfp, set_iqfp] = useState<string>('');

  const message_apenas_numeros_0e5 = ("Apenas números entre 0 e 5 são permitidos.");

  const [error_iqfp, set_error_iqfp] = useState<boolean>(false);
  const [message_iqfp, set_message_iqfp] = useState<string>('');
  const [error_n_parcela, set_error_n_parcela] = useState<boolean>(false);
  const [error_n_sequencia, set_error_n_sequencia] = useState<boolean>(false);
  const [error_area, set_error_area] = useState<boolean>(false);

  const [id_parcela_editar, set_id_parcela_editar] = useState<number>(0);
  const [flag_nova_parcela, set_flag_nova_parcela] = useState<boolean>(false);
  const [open_modal_ver_subparcelas, set_open_modal_ver_subparcelas] = useState<boolean>(false);
  const [open_criar_subparcela, set_open_criar_subparcela] = useState<boolean>(false);
  const [, set_open_editar_subparcela] = useState<boolean>(false);
  const [lista_subparcelas, set_lista_subparcelas] = useState<ISubparcela[]>([]);
  const [obj_subparcela, set_obj_subparcela] = useState<ISubparcela>();
  const [error_numero_seq, set_error_numero_seq] = useState<boolean>(false);
  const [error_numero_sub_parcela, set_error_numero_sub_parcela] = useState<boolean>(false);
  const [error_area_subparcela, set_error_area_subparcela] = useState<boolean>(false);
  const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState<boolean>(false);
  const [open_dialog_tem_a_certeza_que_quer_eliminar_parcela, set_open_dialog_tem_a_certeza_que_quer_eliminar_parcela] = useState<boolean>(false);
  const [open_dialog_tem_a_certeza_que_quer_eliminar_parcelas_selecionadas, set_open_dialog_tem_a_certeza_que_quer_eliminar_parcelas_selecionadas] = useState<boolean>(false);


  const [flag_criar_caderno_de_ano_anterior, set_flag_criar_caderno_de_ano_anterior] = useState<boolean>(false);
  const [flag_eliminar_varias_parcelas, set_flag_eliminar_varias_parcelas] = useState<boolean>(false);



  const [cultura, set_cultura] = useState<string>("");
  const [cor, set_cor] = useState<string>("#123123");

  const [passo_atual, set_passo_atual] = React.useState<number>(0);

  const steps = [
    'Adicionar Ficheiro Indentificação de Beneficiário',
    'Adicionar Ficheiro Indentificação de Exploração',
  ];

  /*************** BENEFICIARIO ******************/
  const getAllBeneficiariosByOrg = async () => {
    try {
      let res = await get(auth.token.cookie_token, `/get_beneficiario_idOrg/${auth.user?.id_org}`);

      if (res.status === 200) {
        set_lista_benefeciario(res.data.result);
        set_lista_benefeciario_pesquisa(res.data.result);
      }
      let res_cadernos_ativos = await get(auth.token.cookie_token, `/get_cadernos_list_ativos/${auth.user?.id_org}`);

      if (res_cadernos_ativos.status === 200) {
        set_lista_cadernos_ativos(res_cadernos_ativos.data.result);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("getAllBeneficiariosByOrg", error, true);
      setMessage(operacao_erro)
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    (async () => {
      await getAllBeneficiariosByOrg();

    })();
  }, []);

  //PESQUISAR BENEFICIARIO 
  const handle_pesquisa = (string_to_search: string) => {
    try {
      set_lista_benefeciario_pesquisa(
        handler_pesquisa(lista_benefeciario, ["nif", "nome"], string_to_search)
      );
    } catch (error) {
      func_print("handle_pesquisa", error, true);
      setMessage(operacao_erro)
      setOpenSnackError(true);
    }
  };

  //EDITAR
  // const handleOpenEditBenef = (el: IBeneficiarios) => {
  //   set_beneficiario(el);
  //   setOpenEditBenef(true);
  // };

  /**************** PARCELAS ****************/
  const getParcelas = async (id_agri_arg: number | undefined) => {
    try {
      setIsLoading(true);

      let response = await get(auth.token.cookie_token, `/get_parcela_agri/${id_agri_arg}`);
      if (response.status === 200) {
        setlistaParcelas(response.data.result);
      } else {
        setMessage(operacao_erro)
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("getParcelas", error, true);
      setMessage(operacao_erro)
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };
  const get_subparcelas_by_parcela = async (id_parcela: number | undefined, numero_seq: number | undefined) => {
    try {
      setIsLoading(true);
      let response = await get(auth.token.cookie_token, `/get_Sub_parcela_parcela_id/${id_parcela}`);
      if (response.status === 200) {
        set_lista_subparcelas(response.data.result);
        if (response.data.result.length === 0) {
          set_open_criar_subparcela(true)
          set_obj_subparcela((old: any) => ({
            ...old,
            'numero_seq': numero_seq,

          }));
        }
      } else {
        setMessage(operacao_erro)
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("get_subparcelas_by_parcela", error, true);
      setMessage(operacao_erro)
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };
  /***************** CADERNO ************************************/
  // GET 
  const handle_open_beneficiario = (el: IBeneficiarios) => {
    try {
      set_beneficiario(el);

      setOpenInfoAboutBeneficiario(true);

      setTelemovel(el.telemovel === undefined || el.telemovel === null ? '' : el.telemovel.toString());
      setTelefone(el.telefone === undefined || el.telefone === null ? '' : el.telefone.toString());
      setEmail(el.email);
      setMorada(el.morada);
      setConcelho(el.Concelho);
      setFreguesia(el.freguesia);
      setCodigo_postal(el.Codigo_postal);
      setDisabled(el.disabled);
      set_nome(el.nome);
      set_nif(el.nif);
      set_nifap(el.nifap);


    } catch (error) {
      func_print("handle_open_beneficiario", error, true);
      setMessage(operacao_erro)
      setOpenSnackError(true);
    }
  };
  //CRIAR
  const handleCreateCaderno = async () => {
    try {
      setIsLoading(true);
      let response = await post(auth.token.cookie_token, `/gerarCaderno`, {
        payload: {
          ano: valueYear?.format("YYYY"),
          id_agri: beneficiario?.id_agri,
          drap: drapChoose,
          cultura_caderno: cultura,
          cor: cor,
          // template_id: obj_template_escolhido.value === -1 ? "0" : obj_tem plate_escolhido.value,
        },
      });

      if (response.status === 200) {

        cadernoAtivo(response.data.result)

        auth.func_setId_rosto_from_caderno(response.data.result.id_rosto);
        auth.func_setNif_agricultor_from_caderno(response.data.result.nif);
        auth.func_setNome_agricultor_from_caderno(response.data.result.nome);
        auth.func_set_id_agricultor_para_eficiencia_alimentar(response.data.result.id_agri)
        auth.func_set_cor(response.data.result.cor)
        auth.func_set_cultura(response.data.result.cultura_caderno)

        setMessage(operacao_sucesso)
        setOpenSnackSuccess(true);
      } else {
        setMessage(operacao_erro)
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error: any) {
      if (error.message.includes('400')) {
        setMessage('Já existe um caderno com o ano selecionado.')

      } else {
        setMessage(operacao_erro)

      }
      func_print("handleCreateCaderno", error, true);
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };
  // CADERNO ATIVO 
  const cadernoAtivo = (caderno: ICaderno) => {

    auth.func_setId_rosto_from_caderno(caderno.id_rosto);
    auth.func_setNif_agricultor_from_caderno(caderno.nif);
    auth.func_setNome_agricultor_from_caderno(caderno.nome);
    auth.func_set_id_agricultor_para_eficiencia_alimentar(caderno.id_agri);

    navigate("/IdentificacaoBenExp",
      { state: caderno, });
  }
  // GERIR CADERNO 
  const handle_gerir_caderno = async (id_rosto: Number) => {
    try {
      setIsLoading(true);
      // set_beneficiario(el);
      let res = await get(auth.token.cookie_token, `/get_rosto_valida/${id_rosto}`);
      if (res.status === 200) {
        // if (res.data.result.activo === 0) {
        //   setflag_gerir_caderno(true);
        // } else {
        set_obj_caderno(res.data.result);
        cadernoAtivo(res.data.result);

        auth.func_setId_rosto_from_caderno(res.data.result.id_rosto);
        auth.func_setNif_agricultor_from_caderno(res.data.result.nif);
        auth.func_setNome_agricultor_from_caderno(res.data.result.nome);
        auth.func_set_id_agricultor_para_eficiencia_alimentar(res.data.result.id_agri)
        // }
      } else {
        setMessage(operacao_erro)
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handle_gerir_caderno", error, true);
      setMessage(operacao_erro)
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  /****************** UPLOAD CANDIDATURA - NOVO CADERNO  **********************************************/
  const novoCaderno = async () => {
    try {
      setIsLoading(true);

      const formData = new FormData();

      formData.append("file", file);
      if (file !== undefined) {
        let response = await post_file(auth.token.cookie_token, "/uploadcandidatura", formData);
        if (response.status === 200) {

          set_obj_caderno(response.data.result.caderno);

          cadernoAtivo(response.data.result.caderno)

          auth.func_setId_rosto_from_caderno(response.data.result.caderno.id_rosto);
          auth.func_setNif_agricultor_from_caderno(response.data.result.caderno.nif);
          auth.func_setNome_agricultor_from_caderno(response.data.result.caderno.nome);
          auth.func_set_id_agricultor_para_eficiencia_alimentar(response.data.result.caderno.id_agri)

          setMessage("Candidatura carregada com sucesso!")
          setOpenSnackSuccess(true);


        } else {
          setMessage("Erro ao carregar o ficheiro.")
          setOpenSnackError(true);
        }
      } else {
        setMessage(operacao_erro)
        setOpenSnackError(true);

      }
      setIsLoading(false);
    } catch (error) {
      func_print("novoCaderno", error, true);
      if ((error as any)?.response?.data?.message) {
        setMessage((error as any).response.data.message);
      } else {
        setMessage("Erro ao carregar o ficheiro.");
      }

      setOpenSnackError(true);
      setIsLoading(false);
    }
  }

  /**************  TAB NAVIGATION ************/
  const handleChangeTabNavigation = async (
    event: React.SyntheticEvent,
    newValue: string
  ) => {
    try {
      await getParcelas(beneficiario?.id_agri);
      setValueTab(newValue);
    } catch (error) {
      func_print("handleChangeTabNavigation", error, true);
    }
  };

  /**************  ONCHANGE CARREGAR FICHEIROS ************/
  const onChange = (file: ChangeEvent) => {
    const { files } = file.target as HTMLInputElement;
    if (files && files.length !== 0) {
      setFile(files[0]);
    } else {
      setMessage("Erro ao carregar o ficheiro.")
      setOpenSnackError(true);
    }
  };

  const chamar_componente_eficiencia = async (id: number) => {

    let response = await get(auth.token.cookie_token, `/get_Tabela_ano_eficiencia_Idagricultor/${id}`);
    if (response.status === 200) {

      const aux_tabela = response.data.result.map((el: any) => {
        if (el.ano === undefined || el.ano !== valueYear?.format("YYYY").toString()) {
          return response.data.result

        } else {
          return el
        }
      })
      // console.log('aux_tabela[0].id_identificacao', aux_tabela[0].id_identificacao)
      // console.log('aux_tabela[0]', aux_tabela[0])
      if (aux_tabela.length <= 0) {
        setflag_gerir_eficiencia(true);
        set_id_agri_eficiencia(id);
      } else {
        let res = await get(auth.token.cookie_token, `/get_caderno_eficiencia_id/${aux_tabela[0].id_identificacao}`);
        if (res.status === 200) {
          setflag_gerir_eficiencia(false);

          auth.func_setId_rosto_from_caderno(res.data.result.id_rosto);
          auth.func_setNif_agricultor_from_caderno(res.data.result.nif);
          auth.func_setNome_agricultor_from_caderno(res.data.result.nome);
          auth.func_set_id_agricultor_para_eficiencia_alimentar(res.data.result.id_agri);

          navigate("/EFIdentBenfExp",
            { state: res.data.result }
          );
        }
      }
    }
  }

  const handle_registar_novo_benef = async () => {
    try {
      let flag_valido_email = false;
      let flag_valido_nif = false;

      if (email.length !== 0 && isValidEmail(email) === false) {
        set_error_email(true);
        flag_valido_email = false;
      } else {
        set_error_email(false);
        flag_valido_email = true;
      }
      if (nif.length !== 0 && verify_nif(nif) === false) {
        set_error_nif(true);
        flag_valido_nif = false;
      } else {
        set_error_nif(false);
        flag_valido_nif = true;
      }
      if (flag_valido_email === true && flag_valido_nif === true) {
        setIsLoading(true);

        let data = await post(auth.token.cookie_token, `/new_beneficiario`, {
          payload: {
            id_agri: 0,
            nome: nome,
            email: email,
            telefone: telefone === undefined || telefone === null ? '' : parseInt(telefone.slice(-9)),
            telemovel: telemovel === undefined || telemovel === null ? '' : parseInt(telemovel.slice(-9)),
            morada: morada,
            Concelho: Concelho,
            freguesia: freguesia,
            Codigo_postal: Codigo_postal,
            nif: nif,
            nifap: nifap,
            disabled: false,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            id_org: auth.user?.id_org,
            uuid: "",
          },
        });


        if (data.status === 200) {

          if (lista_benefeciario.length === 0) {
            set_lista_benefeciario([data.data.result])
          } else {
            set_lista_benefeciario((old) => [...old, data.data.result])
          }

          if (lista_benefeciario_pesquisa.length === 0) {
            set_lista_benefeciario_pesquisa([data.data.result])
          } else {
            set_lista_benefeciario_pesquisa((old) => [...old, data.data.result])
          }
          setMessage(operacao_sucesso)
          func_clean()
          setOpenSnackSuccess(true);
          set_open_modal_criar_benef(false)


        } else {
          setMessage(operacao_erro)

          setOpenSnackError(true);
        }
        setIsLoading(false);
      }
    } catch (error) {
      func_print("handle_registar_novo_benef", error, true);
      if ((error as any)?.response?.data?.message) {
        setMessage((error as any).response.data.message);
      } else {
        setMessage("Erro ao carregar o ficheiro.");
      }
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }
  const updateById = async () => {
    try {
      let flag_valido_email = false;

      if (email.length !== 0 && isValidEmail(email) === false) {
        set_error_email(true);
        flag_valido_email = false;
      } else {
        set_error_email(false);
        flag_valido_email = true;
      }

      if (flag_valido_email === true) {
        setIsLoading(true);

        let data = await post(auth.token.cookie_token, `/update_beneficiario`, {
          payload: {
            id_agri: beneficiario?.id_agri,
            nome: nome,
            email: email,
            telefone: telefone === undefined || telefone === null ? '' : parseInt(telefone.slice(-9)),
            telemovel: telemovel === undefined || telemovel === null ? '' : parseInt(telemovel.slice(-9)),
            morada: morada,
            Concelho: Concelho,
            freguesia: freguesia,
            Codigo_postal: Codigo_postal,
            nif: nif,
            nifap: nifap,
            disabled: disabled,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            id_org: beneficiario?.id_org,
            uuid: "",
          },
        });

        if (data.status === 200) {

          let list_aux = lista_benefeciario.map((el: IBeneficiarios) => {
            if (el.id_agri === data.data.result.id_agri) {
              return data.data.result;
            } else {
              return el;
            }
          });

          set_lista_benefeciario(list_aux);

          let list_pesquisa_aux = lista_benefeciario_pesquisa.map((el: IBeneficiarios) => {
            if (el.id_agri === data.data.result.id_agri) {
              return data.data.result;
            } else {
              return el;
            }
          });

          set_lista_benefeciario_pesquisa(list_pesquisa_aux);
          setMessage(operacao_sucesso)

          setOpenSnackSuccess(true);
          set_flag_editado(false)
          set_error_email(false)
          // handleCloseEditBenef(); 
          // func_clean()
        } else {
          setMessage(operacao_erro)

          setOpenSnackError(true);
        }
        setIsLoading(false);
      }
    } catch (error) {
      func_print("updateById", error, true);
      if ((error as any)?.response?.data?.message) {
        setMessage((error as any).response.data.message);
      } else {
        setMessage("Erro ao carregar o ficheiro.");
      }
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };
  const func_clean = () => {
    set_nome('')
    setEmail('')
    setTelefone('')
    setTelemovel('')
    setMorada('')
    setConcelho('')
    setFreguesia('')
    setCodigo_postal('')
    set_nif('')
    set_nifap('')
    set_error_email(false)
    set_error_nif(false)
    set_flag_nova_parcela(false)

  }

  const handleClose = () => {
    set_flag_nova_parcela(false)

    set_open_modal_criar_benef(false);
    set_open_modal_criar_parcela(false);
    set_flag_editado(false)
    func_clean()
    func_clean_parcela()
    func_clean_subparcela()
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)

  };
  const handleClose_aux = () => {
    setValueTab('1')
    setlistaParcelas([]);
    set_beneficiario(undefined);
    setOpenInfoAboutBeneficiario(false);
    func_clean()
    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_aux(false)
  };

  const func_clean_parcela = () => {
    set_nome_parcela('')
    set_n_sequencia('')
    set_area_parcela('')
    set_n_parcelario('')
    set_iqfp('')
    set_error_n_parcela(false)
    set_error_n_sequencia(false)
    set_error_area(false)
    set_error_iqfp(false)
    set_flag_nova_parcela(false)
    set_id_parcela_editar(0)
  }




  const handle_registar_nova_parcela = async () => {
    try {
      if (error_n_parcela !== true && error_n_sequencia !== true && error_area !== true && error_iqfp !== true) {
        setIsLoading(true);

        let data = await post(auth.token.cookie_token, `/new_parcela`, {
          payload: {
            nome: nome_parcela,
            primeiro_pilar: '',
            uuid: '',
            seccao_finan: '',
            segundo_pilar: '',
            artigo: '',
            iqfp: iqfp,
            forma: '',
            acao: '',
            s_n_l: '',
            Data_ultima_atualizacao: new Date().toISOString(),
            id_parcela: 0,
            multiDec: '',
            id_agri: beneficiario?.id_agri,
            numero_seq: n_sequencia,
            area_gis: area_parcela,
            numero_Parce: n_parcelario,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
          },
        });


        if (data.status === 200) {

          if (listaParcelas.length === 0) {
            setlistaParcelas([data.data.result])
          } else {
            setlistaParcelas((old) => [...old, data.data.result])
          }


          setMessage(operacao_sucesso)
          func_clean_parcela()
          setOpenSnackSuccess(true);
          set_open_modal_criar_parcela(false)


        } else {
          setMessage(operacao_erro)

          setOpenSnackError(true);
        }
        setIsLoading(false);
      }
    } catch (error) {
      func_print("updateById", error, true);
      setMessage(operacao_erro)
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }
  const handle_edit_parcela = async () => {
    try {
      if (error_n_parcela !== true && error_n_sequencia !== true && error_area !== true && error_iqfp !== true) {
        setIsLoading(true);


        let data = await post(auth.token.cookie_token, `/update_parcela`, {
          payload: {
            nome: nome_parcela,
            primeiro_pilar: '',
            uuid: '',
            seccao_finan: '',
            segundo_pilar: '',
            artigo: '',
            iqfp: iqfp,
            forma: '',
            acao: '',
            s_n_l: '',
            Data_ultima_atualizacao: new Date().toISOString(),
            id_parcela: id_parcela_editar,
            multiDec: '',
            id_agri: beneficiario?.id_agri,
            numero_seq: n_sequencia,
            area_gis: area_parcela,
            numero_Parce: n_parcelario,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
          },
        });


        if (data.status === 200) {

          if (listaParcelas.length === 0) {
            setlistaParcelas([data.data.result])
          } else {
            let list_aux = listaParcelas.map((el) => {
              if (el.id_parcela === data.data.result.id_parcela) {
                return data.data.result
              } else {
                return el

              }
            })
            setlistaParcelas(list_aux)
          }


          setMessage(operacao_sucesso)
          func_clean_parcela()
          setOpenSnackSuccess(true);
          set_open_modal_criar_parcela(false)


        } else {
          setMessage(operacao_erro)

          setOpenSnackError(true);
        }
        setIsLoading(false);
      }
    } catch (error) {
      func_print("updateById", error, true);
      setMessage(operacao_erro)
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }
  const func_clean_subparcela = () => {
    set_obj_subparcela(undefined)
    set_open_criar_subparcela(false)
    set_open_editar_subparcela(false)
    set_error_area_subparcela(false)
    set_error_numero_seq(false)
    set_error_numero_sub_parcela(false)
    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  }

  const handle_criar_subparcela = async () => {
    try {

      if (obj_subparcela?.numero_seq === undefined || obj_subparcela?.numero_seq === null) {
        set_error_numero_seq(true)
      } else if (obj_subparcela?.numero_sub_parcela === undefined || obj_subparcela?.numero_sub_parcela === null) {
        set_error_numero_sub_parcela(true)
      } else if (obj_subparcela?.area === undefined || obj_subparcela?.area === null) {
        set_error_area_subparcela(true)
      } else if (error_numero_seq !== true && error_numero_sub_parcela !== true && error_area_subparcela !== true) {
        setIsLoading(true);


        let data = await post(auth.token.cookie_token, `/new_Sub_parcela`, {
          payload: {
            id_sub: 0,
            numero_seq: obj_subparcela?.numero_seq === undefined ? '' : Number(obj_subparcela?.numero_seq),
            numero_sub_parcela: obj_subparcela?.numero_sub_parcela === undefined ? '' : obj_subparcela?.numero_sub_parcela.toString(),
            area: obj_subparcela?.area === undefined ? '' : Number(obj_subparcela?.area.toString().replace(',', '.')),
            id_parcela: parcela_para_ver_subparcelas?.id_parcela,
            classe: obj_subparcela?.classe,
            detalhe: obj_subparcela?.detalhe,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: ''
          },
        });


        if (data.status === 200) {


          if (lista_subparcelas.length === 0) {
            set_lista_subparcelas([data.data.result])
          } else {
            // let list_aux = lista_subparcelas.map((el) => {
            //   if (el.id_sub === data.data.result.id_sub) {
            //     return data.data.result
            //   } else {
            //     return el

            //   }
            // })
            set_lista_subparcelas((old) => [...old, data.data.result])
          }


          setMessage(operacao_sucesso)
          func_clean_subparcela()
          setOpenSnackSuccess(true);
          set_open_criar_subparcela(false)


        } else {
          setMessage(operacao_erro)

          setOpenSnackError(true);
        }
        setIsLoading(false);
      }
    } catch (error) {
      func_print("handle_criar_subparcela", error, true);
      setMessage(operacao_erro)
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }
  const handle_edit_subparcela = async () => {
    try {

      if (obj_subparcela?.numero_seq === undefined || obj_subparcela?.numero_seq === null) {
        set_error_numero_seq(true)
      } else if (obj_subparcela?.numero_sub_parcela === undefined || obj_subparcela?.numero_sub_parcela === null) {
        set_error_numero_sub_parcela(true)
      } else if (obj_subparcela?.area === undefined || obj_subparcela?.area === null) {
        set_error_area_subparcela(true)
      } else if (error_numero_seq !== true && error_numero_sub_parcela !== true && error_area_subparcela !== true) {
        setIsLoading(true);


        let data = await post(auth.token.cookie_token, `/update_Sub_parcela`, {
          payload: {
            id_sub: obj_subparcela?.id_sub,
            numero_seq: obj_subparcela?.numero_seq === undefined ? '' : Number(obj_subparcela?.numero_seq),
            numero_sub_parcela: obj_subparcela?.numero_sub_parcela === undefined ? '' : obj_subparcela?.numero_sub_parcela.toString(),
            area: obj_subparcela?.area === undefined ? '' : Number(obj_subparcela?.area.toString().replace(',', '.')),
            id_parcela: parcela_para_ver_subparcelas?.id_parcela,
            classe: obj_subparcela?.classe,
            detalhe: obj_subparcela?.detalhe,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: ''
          },
        });


        if (data.status === 200) {

          if (lista_subparcelas.length === 0) {
            set_lista_subparcelas([data.data.result])
          } else {
            let list_aux = lista_subparcelas.map((el) => {
              if (el.id_sub === data.data.result.id_sub) {
                return data.data.result
              } else {
                return el

              }
            })
            set_lista_subparcelas(list_aux)
          }


          setMessage(operacao_sucesso)
          func_clean_subparcela()
          setOpenSnackSuccess(true);
          set_open_editar_subparcela(false)


        } else {
          setMessage(operacao_erro)

          setOpenSnackError(true);
        }
        setIsLoading(false);
      }
    } catch (error) {
      func_print("handle_edit_subparcela", error, true);
      setMessage(operacao_erro)
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }
  const onInputChange = (event: any) => {
    const { name, value } = event.target;
    set_flag_editado(true)


    if (name === 'numero_sub_parcela') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_numero_sub_parcela(true)
      } else {
        set_error_numero_sub_parcela(false)
      }
      set_obj_subparcela((old: any) => ({
        ...old,
        [name]: value,

      }));
    } else if (name === 'area') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_area_subparcela(true)
      } else {
        set_error_area_subparcela(false)
      }
      set_obj_subparcela((old: any) => ({
        ...old,
        [name]: value,

      }));
    } else {
      set_obj_subparcela((old: any) => ({
        ...old,
        [name]: value,
      }));
    }

  };

  const handle_delete_subparcela = async () => {
    try {
      setIsLoading(true);

      let res = await del(auth.token.cookie_token,
        `delete_Sub_parcela/${obj_subparcela?.id_sub}`
      );
      if (res.status === 200) {
        let lista_aux: any = lista_subparcelas?.filter((el) => {
          if (el.id_sub !== obj_subparcela?.id_sub) {
            return el
          }
        })
        set_lista_subparcelas(lista_aux === undefined ? [] : lista_aux)
        set_obj_subparcela(undefined)
        if (lista_aux === undefined || lista_aux.length === 0) {
          set_open_criar_subparcela(true)
        }
        setMessage("Registo eliminado com sucesso!");
        set_open_dialog_tem_a_certeza_que_quer_eliminar(false);
        setOpenSnackSuccess(true);

      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handle_delete_subparcela", error, true);
      setIsLoading(false);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
    }
  };
  const handle_delete_parcela = async () => {
    try {
      setIsLoading(true);

      let res = await del(auth.token.cookie_token,
        `delete_parcela/${id_parcela_editar}`
      );
      if (res.status === 200) {
        let lista_aux: any = listaParcelas?.filter((el) => {
          if (el.id_parcela !== id_parcela_editar) {
            return el
          }
        })
        setlistaParcelas(lista_aux === undefined ? [] : lista_aux)
        set_id_parcela_editar(0)
        if (lista_aux === undefined || lista_aux.length === 0) {
          set_open_criar_subparcela(true)
        }
        setMessage("Registo eliminado com sucesso!");
        set_open_dialog_tem_a_certeza_que_quer_eliminar_parcela(false);
        setOpenSnackSuccess(true);

      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handle_delete_parcela", error, true);
      setIsLoading(false);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
    }
  };



  const handle_delete_parcelas_selecionadas = async () => {
    try {
      setIsLoading(true);

      let res = await post(auth.token.cookie_token,
        `delete_multiplas_parcela`,
        {
          ids: listaParcelas_a_eliminar.map((el) => el.id_parcela)
        }
      );
      if (res.status === 200) {
        let lista_aux: any = listaParcelas?.filter((el) => {
          if (!listaParcelas_a_eliminar.includes(el)) {
            return el
          }
        })
        setlistaParcelas(lista_aux === undefined ? [] : lista_aux)

        setMessage("Registos eliminados com sucesso!");
        set_open_dialog_tem_a_certeza_que_quer_eliminar_parcelas_selecionadas(false);
        set_flag_eliminar_varias_parcelas(false)
        setlistaParcelas_a_eliminar([])
        setOpenSnackSuccess(true);

      } else {
        setMessage("Erro ao eliminar registos!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handle_delete_parcelas_selecionadas", error, true);
      setIsLoading(false);
      setMessage("Erro ao eliminar registos!");
      setOpenSnackError(true);
    }
  };
  const handle_replicar_caderno_de_ano_anterior = async () => {
    try {
      setIsLoading(true);
      let response = await post(auth.token.cookie_token, `/duplicarcaderno`, {
        payload: {
          novo_ano: ano_novo_caderno?.format("YYYY"),
          id_caderno: id_rosto_a_replicar, // id_caderno_a_replicar,
          id_agri: beneficiario?.id_agri,
          // id_rosto: id_rosto_a_replicar
        },
      });

      if (response.status === 200) {

        cadernoAtivo(response.data.result)

        auth.func_setId_rosto_from_caderno(response.data.result.id_rosto);
        auth.func_setNif_agricultor_from_caderno(response.data.result.nif);
        auth.func_setNome_agricultor_from_caderno(response.data.result.nome);
        auth.func_set_id_agricultor_para_eficiencia_alimentar(response.data.result.id_agri)

        setMessage(operacao_sucesso)
        setOpenSnackSuccess(true);
      } else {
        setMessage(operacao_erro)
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handle_replicar_caderno_de_ano_anterior", error, true);
      setMessage(operacao_erro)
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };


  const handler_mudar_screen_portal_agricultor = (id_agri: number) => {
    navigate("/pportalagricultor",
      { state: id_agri }
    )
  }


  return (
    <CustomThemeProvider>
      <div className={classes.root}>
        <HomeViewTecnico title=" Identificação do Beneficiário" />

        <main className={classes.contents}>
          <div className={classes.toolbars} />
          <div className={classes.label}>
            <Modal
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              open={open_modal_ver_subparcelas}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                backgroundColor: 'white',
                width: '80%',
                height: '80%',
                flexDirection: 'column',
                borderRadius: 5,
              }}>
                <div style={{
                  width: '100%',
                  display: "flex",
                  alignItems: 'flex-start',
                  justifyContent: 'flex-end',
                  flex: 0.1,
                }}>
                  <Button
                    sx={{ color: "#AAAAAA" }}
                    size="large"
                    onClick={() => {
                      set_open_modal_ver_subparcelas(false)
                      func_clean_subparcela()
                    }}
                  >
                    <CloseIcon />
                  </Button>
                </div>
                {
                  isloading === true ?
                    loader() :
                    <>
                      <div
                        style={{
                          backgroundColor: cores.cor1,
                          display: "flex",
                          alignItems: 'center',
                          justifyContent: 'center',
                          flex: 0.1,
                          fontWeight: 'bold',
                          color: 'white',
                          fontSize: 25,
                          width: '100%',
                          fontFamily: "candara"
                        }}>

                        Subparcelas

                      </div>
                      <div
                        style={{
                          height: '13%',
                          flexDirection: 'row',
                          justifyContent: 'flex-start',
                          alignItems: "center",
                          display: 'flex',
                          width: '97%'
                        }}
                      >

                        <BarraDeFerramentas
                          mostrarBotaoNovo
                          textoBotaoNovo="Adicionar Subparcela"
                          aoClicarNovo={() => {
                            set_obj_subparcela(undefined)
                            set_open_editar_subparcela(false)
                            set_obj_subparcela((old: any) => ({
                              ...old,
                              'numero_seq': parcela_para_ver_subparcelas?.numero_seq,

                            }));
                            set_open_criar_subparcela(true)
                          }}
                        />
                      </div>

                      <div style={{
                        width: '100%',
                        alignItems: 'center',
                        // justifyContent: 'center',
                        // alignItems:'flex-start',
                        justifyContent: 'flex-start',
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',


                      }}>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '97%',
                          // backgroundColor: 'red',
                          border: `1px solid ${cores.cor1}`,
                          borderRadius: 1,
                          marginTop: '2%',
                          marginBottom: '1%'


                        }}>
                          <div
                            style={{
                              display: 'flex',
                              flex: 0.1,
                              flexDirection: 'row',
                              alignItems: 'center',
                              justifyContent: 'center',
                              textAlign: 'center',
                              fontFamily: "candara",

                            }}>Nº Seq</div>
                          <div
                            style={{
                              display: 'flex',
                              flex: 0.1,
                              flexDirection: 'row',
                              alignItems: 'center',
                              justifyContent: 'center',
                              textAlign: 'center',
                              fontFamily: "candara",


                            }}>Nº Subparcela</div>
                          <div
                            style={{
                              display: 'flex',
                              flex: 0.1,
                              flexDirection: 'row',
                              alignItems: 'center',
                              justifyContent: 'center',
                              textAlign: 'center',
                              fontFamily: "candara",


                            }}>Área</div>
                          <div
                            style={{
                              display: 'flex',
                              flex: 0.3,
                              flexDirection: 'row',
                              alignItems: 'center',
                              justifyContent: 'center',
                              textAlign: 'center',
                              fontFamily: "candara",

                            }}>Classe</div>
                          <div
                            style={{
                              display: 'flex',
                              flex: 0.3,
                              flexDirection: 'row',
                              alignItems: 'center',
                              justifyContent: 'center',
                              textAlign: 'center',
                              fontFamily: "candara",

                            }}>Detalhe</div>

                          <div style={{
                            display: 'flex',
                            flex: 0.1,
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                            textAlign: 'center',
                            fontFamily: "candara",

                          }}>
                            Ações
                          </div>
                        </div>

                        <div style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                          justifyContent: 'flex-start',

                          width: '97%',
                          height: '60%',

                          overflowY: 'auto',
                        }}>
                          {lista_subparcelas.length === 0 ? <></> :

                            lista_subparcelas.map((el) => {

                              if (el.id_sub === obj_subparcela?.id_sub) {
                                return (<div style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  width: '100%',
                                  // backgroundColor: 'red',
                                  border: `1px solid ${cores.cor1}`,
                                  borderRadius: 1,


                                }}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flex: 0.1,
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                      justifyContent: 'center',

                                      marginLeft: 1,
                                      marginRight: 1,

                                    }}>

                                    {obj_subparcela?.numero_seq === undefined ? '' : obj_subparcela?.numero_seq}


                                  </div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flex: 0.1,
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      marginLeft: 1,
                                      marginRight: 1,

                                    }}>
                                    <CustomTextField
                                      name="numero_sub_parcela"
                                      value={obj_subparcela?.numero_sub_parcela === undefined ? '' : obj_subparcela?.numero_sub_parcela}
                                      onChange={onInputChange}
                                      error={error_numero_sub_parcela}
                                      helperText={error_numero_sub_parcela ? 'Campo de preenchimento obrigatório' : ""}
                                    />
                                  </div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flex: 0.1,
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      marginLeft: 1,
                                      marginRight: 1,

                                    }}>
                                    <CustomTextField
                                      name="area"
                                      value={obj_subparcela?.area === undefined ? '' : obj_subparcela?.area}
                                      onChange={onInputChange}
                                      error={error_area_subparcela}
                                      helperText={error_area_subparcela ? 'Campo de preenchimento obrigatório' : ""}
                                    />


                                  </div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flex: 0.3,
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      marginLeft: 1,
                                      marginRight: 1,
                                    }}>

                                    <CustomTextField
                                      name="classe"
                                      value={obj_subparcela?.classe === undefined ? '' : obj_subparcela?.classe}
                                      onChange={onInputChange}
                                    />


                                  </div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flex: 0.3,
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      marginLeft: 1,
                                      marginRight: 1,
                                    }}>
                                    <CustomTextField
                                      name="detalhe"
                                      value={obj_subparcela?.detalhe === undefined ? '' : obj_subparcela?.detalhe}
                                      onChange={onInputChange}
                                    />
                                  </div>

                                  <div style={{
                                    display: 'flex',
                                    flex: 0.1,
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'center',

                                  }}>

                                    <ButtonCadernos

                                      mostrarBotaoGravar
                                      aoClicarGravar={() => { handle_edit_subparcela() }}
                                      mostrarBotaoCancelar
                                      aoClicarCancelar={() => {
                                        if (flag_editado) {
                                          set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                        } else {
                                          func_clean_subparcela()
                                          set_flag_editado(false)
                                        }

                                      }}
                                    />

                                  </div>
                                </div>)
                              } else {
                                return (
                                  <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minWidth: '100%',
                                    border: `1px solid ${cores.cor1}`,
                                    borderRadius: 1,
                                    marginTop: 1,


                                  }}>
                                    <div
                                      style={{
                                        display: 'flex',
                                        flex: 0.1,
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center',

                                        marginLeft: 1,
                                        marginRight: 1,
                                      }}>

                                      {el?.numero_seq === undefined ? '' : el?.numero_seq}


                                    </div>
                                    <div
                                      style={{
                                        display: 'flex',
                                        flex: 0.1,
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginLeft: 1,
                                        marginRight: 1,

                                      }}>
                                      {el?.numero_sub_parcela === undefined ? '' : el?.numero_sub_parcela}

                                    </div>
                                    <div
                                      style={{
                                        display: 'flex',
                                        flex: 0.1,
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginLeft: 1,
                                        marginRight: 1,

                                      }}>
                                      {el?.area === undefined ? '' : el?.area}



                                    </div>
                                    <div
                                      style={{
                                        display: 'flex',
                                        flex: 0.3,
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginLeft: 1,
                                        marginRight: 1,

                                      }}>

                                      {el?.classe === undefined ? '' : el?.classe}



                                    </div>
                                    <div
                                      style={{
                                        display: 'flex',
                                        flex: 0.3,
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginLeft: 1,
                                        marginRight: 1,

                                      }}>
                                      {el?.detalhe === undefined ? '' : el?.detalhe}

                                    </div>

                                    <div style={{
                                      display: 'flex',
                                      flex: 0.1,
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                      justifyContent: 'center',

                                    }}>

                                      <ButtonCadernos
                                        mostrarBotaoEditar
                                        aoClicarEditar={() => {
                                          set_open_criar_subparcela(false)

                                          set_obj_subparcela(el)
                                          set_open_editar_subparcela(true)
                                        }}
                                        mostrarBotaoApagar
                                        aoClicarApagar={() => {
                                          set_obj_subparcela(el)

                                          set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                                        }}
                                      />

                                    </div>
                                  </div>
                                )
                              }


                            })



                          }
                        </div>

                        {

                          open_criar_subparcela === false ? <></> :


                            <div style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: '97%',
                              // backgroundColor: 'red',
                              border: `1px solid ${cores.cor1}`,
                              borderRadius: 1,


                            }}>
                              <div
                                style={{
                                  display: 'flex',
                                  flex: 0.1,
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  justifyContent: 'center',

                                  marginLeft: 1,
                                  marginRight: 1,

                                }}>


                                {obj_subparcela?.numero_seq === undefined ? '' : obj_subparcela?.numero_seq}


                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  flex: 0.1,
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  marginLeft: 1,
                                  marginRight: 1,

                                }}>
                                <CustomTextField
                                  name="numero_sub_parcela"
                                  value={obj_subparcela?.numero_sub_parcela === undefined ? '' : obj_subparcela?.numero_sub_parcela}
                                  onChange={onInputChange}
                                  error={error_numero_sub_parcela}
                                  helperText={error_numero_sub_parcela ? 'Campo de preenchimento obrigatório' : ""}
                                />
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  flex: 0.1,
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  marginLeft: 1,
                                  marginRight: 1,

                                }}>
                                <CustomTextField
                                  name="area"
                                  value={obj_subparcela?.area === undefined ? '' : obj_subparcela?.area}
                                  onChange={onInputChange}
                                  error={error_area_subparcela}
                                  helperText={error_area_subparcela ? 'Campo de preenchimento obrigatório' : ""}
                                />


                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  flex: 0.3,
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  marginLeft: 1,
                                  marginRight: 1,
                                }}>

                                <CustomTextField
                                  name="classe"
                                  value={obj_subparcela?.classe === undefined ? '' : obj_subparcela?.classe}
                                  onChange={onInputChange}
                                />


                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  flex: 0.3,
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  marginLeft: 1,
                                  marginRight: 1,
                                }}>
                                <CustomTextField
                                  name="detalhe"
                                  value={obj_subparcela?.detalhe === undefined ? '' : obj_subparcela?.detalhe}
                                  onChange={onInputChange}
                                />
                              </div>

                              <div style={{
                                display: 'flex',
                                flex: 0.1,
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center',

                              }}>

                                <ButtonCadernos

                                  mostrarBotaoGravar
                                  aoClicarGravar={() => { handle_criar_subparcela() }}
                                  mostrarBotaoCancelar
                                  aoClicarCancelar={() => {
                                    if (flag_editado) {
                                      set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                    } else {
                                      func_clean_subparcela()
                                      set_flag_editado(false)
                                    }

                                  }}
                                />

                              </div>
                            </div>
                        }
                      </div>


                    </>
                }
                <ConfirmDialog
                  open={open_dialog_tem_a_certeza_que_quer_eliminar}
                  onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
                  onConfirm={handle_delete_subparcela}
                  message="Deseja eliminar o registo?"
                />
              </div>



            </Modal>
            <ConfirmDialog
              open={open_dialog_tem_a_certeza_que_quer_eliminar_parcela}
              onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar_parcela(false)}
              onConfirm={handle_delete_parcela}
              message="Deseja eliminar o registo?"
            />
            <ConfirmDialog
              open={open_dialog_tem_a_certeza_que_quer_eliminar_parcelas_selecionadas}
              onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar_parcelas_selecionadas(false)}
              onConfirm={handle_delete_parcelas_selecionadas}
              message="Deseja eliminar os registos selecionados?"
            />
            <Snackbar
              open={openSnackSuccess}
              autoHideDuration={2000}
              onClose={() => setOpenSnackSuccess(false)}
            >
              <Alert
                onClose={() => setOpenSnackSuccess(false)}
                severity="success"
                sx={{ width: "100%" }}
              >
                {message}
              </Alert>
            </Snackbar>
            <Snackbar
              open={openSnackError}
              autoHideDuration={2000}
              onClose={() => setOpenSnackError(false)}
            >
              <Alert
                onClose={() => setOpenSnackError(false)}
                severity="error"
                sx={{ width: "100%" }}
              >
                {message}

              </Alert>
            </Snackbar>
            <ConfirmDialog
              open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
              onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
              onConfirm={() => handleClose()}
              message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
            <ConfirmDialog
              open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes_aux}
              onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_aux(false)}
              onConfirm={() => handleClose_aux()}
              message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
            {/************** CARREGAR FICHEIRO IE ***************/}
            <Box
              width={"100%"}
              height="auto"
              display="flex"
              justifyContent="end"
              marginRight={10}
            >
              <BarraDeFerramentas
                mostrarBotaoUpload
                textoBotaoUpload="Importar Dados Beneficiário"
                aoClicarUpload={() => setuploadIE(true)}
              />
              <div style={{

                marginLeft: 5
              }}>
                <BarraDeFerramentas
                  mostrarBotaoNovo
                  textoBotaoNovo="Adicionar Beneficiário"
                  aoClicarNovo={() => { set_open_modal_criar_benef(true) }}
                />
              </div>

              {/************** POPUP CARREGAR FICHEIRO IE ***************/}
              <Dialog
                open={uploadIE}
                onClose={() => setuploadIE(false)}


              >
                <Stack direction="column" sx={{ padding: 5 }}>

                  <div style={{
                    display: "flex",
                    paddingBottom: 30
                  }}>

                    <div style={{
                      display: "flex",
                      flex: 0.9
                    }}>
                      <DialogTitle sx={{ fontFamily: "candara" }}>
                        Importar Dados Beneficiário
                      </DialogTitle>
                    </div>

                    <div style={{
                      display: "flex",
                      flex: 0.1
                    }}>
                      <Button
                        color="inherit"
                        size="small"
                        onClick={() => setuploadIE(false)}
                      >
                        <ClearIcon />
                      </Button>
                    </div>

                  </div>

                  <div>
                    <Stepper activeStep={passo_atual} alternativeLabel>
                      {steps.map((label) => (
                        <Step key={label} sx={{
                          '& .MuiStepLabel-root .Mui-completed': {
                            color: cores.cor3, // circle color (COMPLETED)
                          },
                          '& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel':
                          {
                            color: cores.cor2, // Just text label (COMPLETED)
                          },
                          '& .MuiStepLabel-root .Mui-active': {
                            color: cores.cor1, // circle color (ACTIVE)
                          },
                          '& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel':
                          {
                            color: cores.cor1, // Just text label (ACTIVE)
                          },
                          '& .MuiStepLabel-root .Mui-active .MuiStepIcon-text': {
                            fill: 'white', // circle's number (ACTIVE)
                          },
                        }}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>

                  </div>

                  {
                    passo_atual === 0 ?
                      <DocsUploadIB
                        send_to_next_step={set_passo_atual}
                        set_beneficiario_pesquisa={set_lista_benefeciario_pesquisa}
                        set_beneficiario={set_lista_benefeciario}
                        beneficiario={lista_benefeciario}
                        beneficiario_pesquisa={lista_benefeciario_pesquisa}
                      />
                      :
                      <DocsUploadIE
                        onCloseDialog={() => {
                          setuploadIE(false)
                          set_passo_atual(0)
                        }}
                        set_beneficiario_pesquisa={set_lista_benefeciario_pesquisa}
                        set_beneficiario={set_lista_benefeciario}
                        beneficiario={lista_benefeciario}
                        beneficiario_pesquisa={lista_benefeciario_pesquisa}
                      />

                  }

                </Stack>


              </Dialog>
            </Box>
            <Dialog
              open={uploadIE_from_parcelas}
              onClose={() => setuploadIE_from_parcelas(false)}


            >
              <Stack direction="column" sx={{ padding: 5 }}>

                <div style={{
                  display: "flex",
                  paddingBottom: 30
                }}>

                  <div style={{
                    display: "flex",
                    flex: 0.9
                  }}>
                    <DialogTitle sx={{ fontFamily: "candara" }}>
                      Importar Ficheiro IE
                    </DialogTitle>
                  </div>

                  <div style={{
                    display: "flex",
                    flex: 0.1
                  }}>
                    <Button
                      color="inherit"
                      size="small"
                      onClick={() => setuploadIE_from_parcelas(false)}
                    >
                      <ClearIcon />
                    </Button>
                  </div>

                </div>


                <DocsUploadIE
                  onCloseDialog={() => setuploadIE_from_parcelas(false)}
                  set_beneficiario_pesquisa={set_lista_benefeciario_pesquisa}
                  set_beneficiario={set_lista_benefeciario}
                  beneficiario={lista_benefeciario}
                  beneficiario_pesquisa={lista_benefeciario_pesquisa}
                />



              </Stack>


            </Dialog>
            {/************** Beneficiario ***************/}
            {openInfoAboutBeneficiario === false ? (
              <></>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "end",
                  width: "100%",
                  maxHeight: 40,
                }}
              >
                <BarraDeFerramentas
                  mostrarBotaoCancelar
                  aoClicarCancelar={() => {

                    if (flag_editado) {
                      set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_aux(true)

                    } else {
                      // setValueTab('1')
                      // setlistaParcelas([]);
                      // set_beneficiario(undefined);
                      // setOpenInfoAboutBeneficiario(false);
                      // func_clean()
                      // set_flag_editado(false)
                      // set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
                      handleClose_aux()

                    }


                  }}
                />
              </Box>
            )}

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                width: "100%",
                justifyContent: "center",
              }}
            >
              {/************** DIV DO LADO ESQUERDO ***************/}
              <div
                id="dados"
                style={{
                  height: "auto",
                  flex: openInfoAboutBeneficiario === false ? 1 : 0.4,
                  paddingRight: 10,
                  display: "flex",
                }}
              >
                <TableContainer
                  component={Paper}
                  variant="outlined"
                  sx={{
                    height: "100%",
                    width: "100%",
                  }}
                >
                  {openInfoAboutBeneficiario === false ? (
                    <>
                      <CardHeader
                        className={classes.header}
                        title="Pesquisar Beneficiário"
                      />
                      <CardContent>
                        <div style={{ display: "flex" }}>
                          <TextField
                            fullWidth
                            id="username"
                            label="NIF ou Nome do Beneficiário"
                            placeholder="NIF ou Nome do Beneficiário"
                            margin="normal"
                            onChange={(e) => {
                              handle_pesquisa(e.target.value);
                            }}
                            value={string_para_pesquisar}
                          />
                        </div>
                      </CardContent>
                    </>
                  ) : (
                    <></>
                  )}

                  {/*********** DADOS DO BENEFICIARIO ***********/}
                  {isloading ? (
                    <Box sx={{ justifyContent: "-moz-initial" }}>
                      <LoadingVulpesSmall />
                    </Box>
                  ) : openInfoAboutBeneficiario === false ? (
                    <TableContainer
                      component={Paper}
                      variant="outlined"
                      sx={{ height: "55vh", width: "auto", m: 2, padding: 2 }}
                    >
                      <table style={{ width: "100%" }}>
                        <TableHead>
                          <TableRow>
                            <StyledTableCellCabecalho>
                              NIF
                            </StyledTableCellCabecalho>
                            <StyledTableCellCabecalho colSpan={2}>
                              Nome
                            </StyledTableCellCabecalho>
                            <StyledTableHeadWithoutBorder>
                              Ações
                            </StyledTableHeadWithoutBorder>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {lista_benefeciario_pesquisa !== undefined &&
                            lista_benefeciario_pesquisa.length !== 0 &&
                            lista_benefeciario_pesquisa.map((el, key) => {
                              return (
                                <TableRow key={key}>
                                  <StyledTableCellCabecalho width="20%">
                                    {el.nif}
                                  </StyledTableCellCabecalho>
                                  <StyledTableCellCabecalho width="40%" >
                                    {el.nome}
                                  </StyledTableCellCabecalho>
                                  <StyledTableCellCabecalho sx={{ color: cores.cor2 }}>
                                    {el.disabled === true ? "Inativo" : ""}
                                  </StyledTableCellCabecalho>
                                  <StyledTableHeadWithoutBorder width="40%">
                                    <div>


                                      <div>

                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            "& button": { m: 1 },
                                          }}
                                        >
                                          <Button
                                            sx={{
                                              backgroundColor: "#c94f1e",
                                              fontFamily: "candara",
                                              color: "#ffffff",
                                              "&:hover": {
                                                backgroundColor: "transparent",
                                                color: "#7e2706",
                                              },
                                            }}
                                            size="small"
                                            onClick={() => handle_open_beneficiario(el)}
                                          >
                                            <Search />
                                          </Button>
                                          {/* <Button
                                        sx={{
                                          backgroundColor: el.disabled === true ? cores.cor2 : cores.cor1,
                                          fontFamily: "candara",
                                          color: "#ffffff",
                                          "&:hover": {
                                            backgroundColor: "transparent",
                                            color: "#7e2706",
                                          },
                                        }}
                                        size="small"
                                        onClick={() => handleOpenEditBenef(el)}
                                        disabled={el.disabled === true ? true : false}
                                      >
                                        <EditIcon />
                                      </Button> */}
                                          <Button
                                            size="small"
                                            sx={{
                                              backgroundColor: el.disabled === true ? cores.cor2 : cores.cor1,
                                              color: "#ffffff",
                                              "&:hover": {
                                                backgroundColor: "transparent",
                                                color: "#7e2706",
                                              },
                                              fontFamily: "candara",
                                            }}
                                            onClick={() => handler_mudar_screen_portal_agricultor(el.id_agri)}
                                            disabled={el.disabled}
                                          >
                                            Portal do Agricultor
                                          </Button>
                                          <Button
                                            size="small"
                                            sx={{
                                              backgroundColor: el.disabled === true ? cores.cor2 : cores.cor1,
                                              color: "#ffffff",
                                              "&:hover": {
                                                backgroundColor: "transparent",
                                                color: "#7e2706",
                                              },
                                              fontFamily: "candara",
                                            }}
                                            // onClick={() => handle_gerir_caderno(el)}
                                            onClick={() => {
                                              setflag_gerir_caderno(true)
                                              set_beneficiario(el)

                                            }}

                                            disabled={el.disabled}
                                          >
                                            Criar Caderno
                                          </Button>
                                          <Button
                                            size="small"
                                            sx={{
                                              backgroundColor: el.disabled === true ? cores.cor2 : cores.cor1,
                                              color: "#ffffff",
                                              "&:hover": {
                                                backgroundColor: "transparent",
                                                color: "#7e2706",
                                              },
                                              fontFamily: "candara",
                                            }}
                                            onClick={() => chamar_componente_eficiencia(el.id_agri)}
                                            disabled={el.disabled}
                                          >
                                            Eficiência Alimentar
                                          </Button>
                                        </Box>
                                      </div>

                                      {/* {
                                      lista_cadernos_ativos.length === 0 ? <></> :
                                          <div>
                                            Lista de Cadernos Ativos
                                          </div>
                                      } */}
                                      {lista_cadernos_ativos.some(
                                        (elem) => elem.id_agri === el.id_agri
                                      ) && (
                                          <div>Lista de Cadernos Ativos</div>
                                        )}

                                      {lista_cadernos_ativos.length === 0 ? <></> :
                                        <div style={{
                                          display: 'flex',
                                          flexDirection: 'row',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          flexWrap: 'wrap',


                                        }}>

                                          {lista_cadernos_ativos.map((elem, key) => {
                                            if (elem.id_agri === el.id_agri)

                                              return (
                                                <div key={key}
                                                  style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    alignSelf: "center",
                                                    justifyContent: 'center',
                                                    width: '150px',
                                                    // marginTop: 5,
                                                    borderRadius: 5,
                                                    marginLeft: 1,
                                                    marginRight: 1,
                                                    border: `1px solid silver`,
                                                    cursor: 'pointer',
                                                    backgroundColor: hover.flag && hover.id === elem.id_rosto ? '#f5f5f5' : 'white',
                                                    boxShadow: hover.flag && hover.id === elem.id_rosto ? '0 4px 10px rgba(0,0,0,0.15)' : 'none',
                                                    transition: 'all 0.2s ease',
                                                  }}
                                                  onMouseEnter={() => setHover({ flag: true, id: elem.id_rosto })}
                                                  onMouseLeave={() => setHover({ flag: false, id: elem.id_rosto })}
                                                  // size="small"
                                                  onClick={() => {
                                                    handle_gerir_caderno(elem.id_rosto)
                                                  }}
                                                >
                                                  {/* <div style={{
                                                  backgroundColor: elem.cor,
                                                  borderRadius: 1000,
                                                  width: 10,
                                                  height: 10,
                                                  marginRight:4,
                                                  marginLeft:4

                                                }}>

                                                </div> */}
                                                  <div>
                                                    {' ' + elem.cultura_caderno + ' ' + elem.ano}
                                                  </div>
                                                  <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: '150px',
                                                    // marginTop: 5,
                                                    borderRadius: 5,
                                                    marginLeft: 1,
                                                    marginRight: 1,
                                                    border: `2px solid ${elem.cor}`,
                                                  }}>
                                                  </div>
                                                </div>

                                              )
                                          })}


                                        </div>

                                      }


                                    </div>

                                  </StyledTableHeadWithoutBorder>
                                </TableRow>
                              );
                            })}
                        </TableBody>
                      </table>
                    </TableContainer>
                  ) : (
                    <>
                      <TableHead>
                        <TableRow>
                          <StyledTableHeadWithoutBorder sx={{
                            height: 50, width: "100%", fontFamily: "candara",
                            color: cores.cor1, fontSize: 24
                          }}>
                            Visualizar Beneficiário
                          </StyledTableHeadWithoutBorder>
                          <StyledTableCellCabecalho sx={{ width: "80%", paddingRight: 5, color: cores.cor2 }}>
                            {beneficiario?.disabled === true ? "Inativo" : ""}
                          </StyledTableCellCabecalho>
                        </TableRow>
                      </TableHead>
                      <CardContent>

                        <div>
                          <TextField
                            fullWidth
                            id="name"
                            label="Nome"
                            placeholder="Nome"
                            value={nome}
                            onChange={(e) => {
                              set_flag_editado(true)

                              set_nome(e.target.value)
                            }}
                            sx={{
                              paddingRight: "5px",
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#000000",
                              },
                            }}
                          />
                          <TextField
                            fullWidth
                            id="nif"
                            label="NIF"
                            placeholder="NIF"
                            margin="normal"
                            sx={{
                              width: "50%",
                              paddingRight: "5px",
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#000000",
                              },
                            }}
                            value={nif}
                            onChange={(e) => {
                              set_flag_editado(true)

                              set_nif(e.target.value)
                            }}
                          />
                          <TextField
                            fullWidth
                            id="nifap"
                            label="NIFAP"
                            placeholder="NIFAP"
                            margin="normal"
                            sx={{
                              width: "50%",
                              paddingRight: "5px",
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#000000",
                              },
                            }}
                            value={nifap}
                            onChange={(e) => {
                              set_flag_editado(true)

                              set_nifap(e.target.value)
                            }}
                          />
                          <TextField
                            fullWidth
                            id="morada"
                            label="Morada"
                            placeholder="Morada"
                            margin="normal"
                            sx={{
                              width: "70%",
                              paddingRight: "5px",
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#000000",
                              },
                            }}
                            value={morada}
                            onChange={(e) => {
                              set_flag_editado(true)

                              setMorada(e.target.value)
                            }}
                          />
                          {/* <TextField
                            fullWidth
                            id="cpostal"
                            label="Código Postal"
                            placeholder="Código Postal"
                            margin="normal"
                            sx={{
                              width: "30%",
                              paddingRight: "5px",
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#000000",
                              },
                            }}
                            value={beneficiario?.Codigo_postal}
                          /> */}
                          <PatternFormat
                            format="%%%%-%%%"
                            customInput={TextField}
                            label="Código Postal"
                            patternChar="%"
                            value={Codigo_postal || ""}
                            margin="normal"
                            sx={{ width: "30%", paddingRight: "5px" }}
                            onChange={(e: any) => {
                              set_flag_editado(true)

                              setCodigo_postal(e.target.value)
                            }}
                          />
                          <TextField
                            fullWidth
                            id="concelho"
                            label="Concelho"
                            placeholder="Concelho"
                            margin="normal"
                            sx={{
                              width: "50%",
                              paddingRight: "5px",
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#000000",
                              },
                            }}
                            value={Concelho}
                            onChange={(e) => {

                              set_flag_editado(true)

                              setConcelho(e.target.value)
                            }}
                          />
                          <TextField
                            fullWidth
                            id="freguesia"
                            label="Freguesia"
                            placeholder="Freguesia"
                            margin="normal"
                            sx={{
                              width: "50%",
                              paddingRight: "5px",
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#000000",
                              },
                            }}
                            value={freguesia}
                            onChange={(e) => {
                              set_flag_editado(true)
                              setFreguesia(e.target.value)
                            }}
                          />
                          {/* <TextField
                            fullWidth
                            id="telefone"
                            label="Telefone"
                            placeholder="Telefone"
                            margin="normal"
                            disabled
                            sx={{
                              width: "30%",
                              paddingRight: "5px",
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#000000",
                              },
                            }}
                            value={beneficiario?.telefone}
                          /> */}

                          <div
                            style={{
                              flex: 0.5,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              border: `1px solid silver`,
                              fontSize: 14,
                              borderRadius: 4,
                              marginRight: 3,
                              width: "100%",
                              marginTop: '10px',

                              paddingRight: "5px",
                            }}
                          >
                            <PhoneInput
                              defaultCountry="PT"
                              placeholder="Número de telefone"
                              value={telefone}
                              onChange={(e: any) => {
                                set_flag_editado(true)

                                setTelefone(e);
                              }}
                              style={{
                                width: "90%",
                                height: 51,
                              }}
                            />
                          </div>
                          {/* <TextField
                            fullWidth
                            id="telemovel"
                            label="Telemóvel"
                            placeholder="Telemóvel"
                            margin="normal"
                            disabled
                            sx={{
                              width: "30%",
                              paddingRight: "5px",
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#000000",
                              },
                            }}
                            value={beneficiario?.telemovel}
                          /> */}

                          <div
                            style={{
                              flex: 0.5,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              border: `1px solid silver`,
                              fontSize: 14,
                              borderRadius: 4,
                              marginRight: 3,
                              width: "100%",
                              marginTop: '20px',
                              paddingRight: "5px",
                            }}
                          >
                            <PhoneInput
                              defaultCountry="PT"
                              placeholder="Número de Telemóvel"
                              value={telemovel}
                              onChange={(e: any) => {
                                set_flag_editado(true)

                                setTelemovel(e);
                              }}
                              style={{
                                width: "90%",
                                height: 51,
                              }}
                            />
                          </div>
                          <TextField
                            value={email}
                            error={error_email}
                            helperText={error_email === true ? "Email inválido" : ""}
                            fullWidth
                            id="email"
                            label="E-mail"
                            placeholder="E-mail"
                            margin="normal"
                            sx={{
                              width: "100%",
                              paddingRight: "5px",
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#000000",
                              },
                            }}
                            onChange={(e) => {

                              set_flag_editado(true)
                              setEmail(e.target.value)
                            }}
                          />
                        </div>
                        <div style={{
                          display: "flex",
                          alignItems: 'center',
                          justifyContent: 'flex-end',
                        }}>

                          <CardActions>
                            <BarraDeFerramentas
                              mostrarBotaoGravar
                              aoClicarGravar={() => updateById()}
                            />

                          </CardActions>
                        </div>
                      </CardContent>
                    </>
                  )}
                  <Dialog
                    open={open_modal_criar_benef}
                    onClose={() => {
                      set_open_modal_criar_benef(false)


                    }}
                    fullWidth
                    maxWidth="md"
                  >
                    <Stack direction="row">
                      <DialogTitle sx={{ fontFamily: "candara" }}>
                        Registar novo Beneficiário
                      </DialogTitle>
                      <div style={{ marginLeft: "auto", marginRight: 0 }}>
                        <IconButton
                          color="info"
                          size="small"
                          onClick={() => {

                            if (flag_editado) {
                              set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)

                            } else {
                              set_open_modal_criar_benef(false)
                              func_clean()
                            }


                          }}
                        >
                          <CloseIcon color="action" />
                        </IconButton>
                      </div>
                    </Stack>
                    {isloading ? (
                      <LoadingVulpes />
                    ) : (
                      <div id="novobeneficiario">
                        <CardContent>
                          <Table>
                            <TextField
                              fullWidth
                              id="name"
                              label="Nome Completo"
                              placeholder="Nome Completo"
                              required
                              margin="normal"
                              sx={{ width: "70%", paddingRight: "5px" }}
                              value={nome}
                              onChange={(e) => {
                                set_nome(e.target.value)

                                set_flag_editado(true)

                              }}

                            />

                            <TextField
                              fullWidth
                              id="nif"
                              label="NIF"
                              placeholder="NIF"
                              required
                              margin="normal"
                              sx={{ width: "15%", paddingRight: "5px" }}
                              value={nif}
                              onChange={(e) => {
                                set_flag_editado(true)
                                set_nif(e.target.value)
                              }}
                              error={error_nif}
                              helperText={error_nif === true ? "NIF inválido" : ""}

                            />

                            <TextField
                              fullWidth
                              id="nifap"
                              label="NIFAP"
                              placeholder="NIFAP"
                              required
                              margin="normal"
                              sx={{ width: "15%", paddingRight: "5px" }}
                              value={nifap}
                              onChange={(e) => {
                                set_flag_editado(true)

                                set_nifap(e.target.value)
                              }}

                            />

                            <TextField
                              fullWidth
                              id="morada"
                              label="Morada"
                              required
                              placeholder="Morada"
                              margin="normal"
                              sx={{ width: "70%", paddingRight: "5px" }}
                              value={morada}
                              onChange={(e) => {
                                set_flag_editado(true)

                                setMorada(e.target.value)
                              }}
                            />

                            <PatternFormat
                              format="%%%%-%%%"
                              customInput={TextField}
                              label="Código Postal"
                              patternChar="%"
                              value={Codigo_postal || ""}
                              margin="normal"
                              sx={{ width: "15%", paddingRight: "5px" }}
                              onChange={(e: any) => {
                                set_flag_editado(true)

                                setCodigo_postal(e.target.value)
                              }}
                            />

                            <TextField
                              fullWidth
                              id="concelho"
                              label="Concelho"
                              placeholder="Concelho"
                              margin="normal"
                              sx={{ width: "15%", paddingRight: "5px" }}
                              value={Concelho}
                              onChange={(e) => {
                                set_flag_editado(true)

                                setConcelho(e.target.value)
                              }}
                            />
                            <Stack direction="row">
                              <TextField
                                fullWidth
                                id="freguesia"
                                label="Freguesia"
                                placeholder="Freguesia"
                                margin="normal"
                                sx={{ width: "15%", paddingRight: "5px" }}
                                value={freguesia}
                                onChange={(e) => {
                                  set_flag_editado(true)
                                  setFreguesia(e.target.value)
                                }}
                              />

                              <div
                                style={{
                                  flex: 0.5,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  border: `1px solid silver`,
                                  fontSize: 14,
                                  borderRadius: 4,
                                  marginRight: 3,
                                  width: "15%",
                                  paddingRight: "5px",
                                }}
                              >
                                <PhoneInput
                                  defaultCountry="PT"
                                  placeholder="Número de telefone"
                                  value={telefone}
                                  onChange={(e: any) => {
                                    set_flag_editado(true)

                                    setTelefone(e);
                                  }}
                                  style={{
                                    width: "90%",
                                    height: 51,
                                  }}
                                />
                              </div>

                              <div
                                style={{
                                  flex: 0.5,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  border: `1px solid silver`,
                                  fontSize: 14,
                                  borderRadius: 4,
                                  marginRight: 3,
                                  width: "15%",
                                  paddingRight: "5px",
                                }}
                              >
                                <PhoneInput
                                  defaultCountry="PT"
                                  placeholder="Número de Telemóvel"
                                  value={telemovel}
                                  onChange={(e: any) => {
                                    set_flag_editado(true)

                                    setTelemovel(e);
                                  }}
                                  style={{
                                    width: "90%",
                                    height: 51,
                                  }}
                                />
                              </div>
                            </Stack>
                            <div style={{
                              display: 'flex',
                              alignItems: "center",
                              justifyContent: 'center',
                            }}>


                              <TextField
                                error={error_email}
                                helperText={error_email === true ? "Email inválido" : ""}
                                fullWidth
                                id="email"
                                label="E-mail"
                                placeholder="E-mail"
                                required
                                margin="normal"
                                sx={{ width: "55%", paddingRight: "5px" }}
                                value={email}
                                onChange={(e) => {
                                  set_flag_editado(true)

                                  setEmail(e.target.value)
                                }}
                              />
                            </div>

                          </Table>
                          <div style={{
                            display: "flex",
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                          }}>

                            <CardActions>
                              <BarraDeFerramentas
                                mostrarBotaoGravar
                                aoClicarGravar={() => handle_registar_novo_benef()}
                              />

                            </CardActions>
                          </div>

                        </CardContent>
                      </div>
                    )}
                  </Dialog>
                  <Dialog
                    open={open_modal_criar_parcela}
                    onClose={() => {
                      set_open_modal_criar_parcela(false)


                    }}
                    fullWidth
                    maxWidth="md"
                  >
                    <Stack direction="row">
                      <DialogTitle sx={{ fontFamily: "candara" }}>
                        Registar nova Parcela
                      </DialogTitle>
                      <div style={{ marginLeft: "auto", marginRight: 0 }}>
                        <IconButton
                          color="info"
                          size="small"
                          onClick={() => {

                            if (flag_editado) {
                              set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)

                            } else {
                              set_open_modal_criar_parcela(false)
                              func_clean_parcela()
                            }


                          }}
                        >
                          <CloseIcon color="action" />
                        </IconButton>
                      </div>
                    </Stack>
                    {isloading ? (
                      <LoadingVulpes />
                    ) : (
                      <div id="novobeneficiario">
                        <CardContent>
                          <Table>
                            <TextField
                              fullWidth
                              label="Nº Parcelário"
                              placeholder="Nº Parcelário"
                              required
                              margin="normal"
                              sx={{ width: "50%", paddingRight: "5px" }}
                              value={n_parcelario}
                              onChange={(e) => {
                                set_n_parcelario(e.target.value)
                                let value = e.target.value

                                if (!/^[0-9,.]*$/.test(value)) {
                                  set_error_n_parcela(true);
                                } else {
                                  set_error_n_parcela(false);
                                }
                                set_flag_editado(true)

                              }}
                              error={error_n_parcela}
                              helperText={error_n_parcela === true ? "Inválido" : ""}

                            />

                            <TextField
                              fullWidth
                              label="Nº Sequência"
                              placeholder="Nº Sequência"
                              required
                              margin="normal"
                              sx={{ width: "50%", paddingRight: "5px" }}
                              value={n_sequencia}
                              onChange={(e) => {

                                set_flag_editado(true)
                                let value = e.target.value

                                if (!/^[0-9,.]*$/.test(value)) {
                                  set_error_n_sequencia(true);
                                } else {
                                  set_error_n_sequencia(false);
                                }
                                set_n_sequencia(e.target.value)
                              }}
                              error={error_n_sequencia}
                              helperText={error_n_sequencia === true ? "Inválido" : ""}

                            />

                            <TextField
                              fullWidth
                              label="Nome da Parcela"
                              placeholder="Nome da Parcela"
                              required
                              margin="normal"
                              sx={{ width: "100%", paddingRight: "5px" }}
                              value={nome_parcela}
                              onChange={(e) => {
                                set_flag_editado(true)

                                set_nome_parcela(e.target.value)
                              }}
                            />

                            <TextField
                              fullWidth
                              label="Área (ha)"
                              required
                              placeholder="Área (ha)"
                              margin="normal"
                              sx={{ width: "50%", paddingRight: "5px" }}
                              value={area_parcela}
                              onChange={(e) => {
                                set_flag_editado(true)
                                let value = e.target.value

                                if (!/^[0-9,.]*$/.test(value)) {
                                  set_error_area(true);
                                } else {
                                  set_error_area(false);
                                }
                                set_area_parcela(e.target.value)
                              }}
                              error={error_area}
                              helperText={error_area === true ? "Inválido" : ""}
                            />

                            <TextField
                              error={error_iqfp}
                              helperText={error_iqfp === true ? message_iqfp : ""}
                              fullWidth
                              id="IQFP"
                              label="IQFP"
                              placeholder="IQFP"
                              margin="normal"
                              sx={{ width: "50%", paddingRight: "5px" }}
                              value={iqfp}
                              onChange={(e) => {
                                set_flag_editado(true)

                                set_iqfp(e.target.value)
                                let value = e.target.value
                                if (!/^[0-5]$/.test(value.trim())) {
                                  set_error_iqfp(true);
                                  set_message_iqfp(message_apenas_numeros_0e5);
                                }

                                if (!/^[0-9]*$/.test(value.trim())) {
                                  set_error_iqfp(true);
                                  set_message_iqfp("Apenas números são permitidos.");

                                }
                                const intValue = parseInt(value, 10);
                                if ((isNaN(intValue) || intValue < 0 || intValue > 5) || value.trim().length > 1) {
                                  set_error_iqfp(true);
                                  set_message_iqfp("Introduza um número entre 0 a 5.");

                                } else {
                                  set_error_iqfp(false);
                                  set_message_iqfp("");
                                }
                              }}
                            />
                          </Table>
                          <div style={{
                            display: "flex",
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                          }}>

                            <CardActions>
                              <BarraDeFerramentas
                                mostrarBotaoGravar
                                aoClicarGravar={() =>

                                  flag_nova_parcela === true ?
                                    handle_registar_nova_parcela()
                                    :
                                    handle_edit_parcela()
                                }
                              />

                            </CardActions>
                          </div>

                        </CardContent>
                      </div>
                    )}
                  </Dialog>
                  {/********************** UPDATE BENEFICIARIO ************************/}
                  {/* <Dialog
                    open={openEditBenef}
                    onClose={() => setOpenEditBenef(false)}
                    fullWidth
                    maxWidth="md"
                  >

                    <UpdatePopup
                      dados={beneficiario}
                      lista={lista_benefeciario}
                      lista_pesquisa={lista_benefeciario_pesquisa}
                      set_lista={(lista: Array<IBeneficiarios>) =>
                        set_lista_benefeciario(lista)
                      }
                      set_lista_pesquisa={(lista: Array<IBeneficiarios>) =>
                        set_lista_benefeciario_pesquisa(lista)
                      }
                      handleCloseEditBenef={() => setOpenEditBenef(false)}
                    />
                  </Dialog> */}

                  {/********************* CRIAR CADERNO MANUAL OU COM CANDIDATURA **************************/}
                  {flag_gerir_caderno === true ? (

                    <Modal
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                      open={flag_gerir_caderno}
                    >
                      <div style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        backgroundColor: 'white',
                        width: '40%',
                        height: '80%',
                        flexDirection: 'column',
                        borderRadius: 5,
                      }}>
                        {/* <div style={{
                          backgroundColor:'green',
                          width: '100%',
                          // paddingTop: '20px',

                        }}> */}

                        <div style={{ marginLeft: "auto" }}>
                          <BarraDeFerramentas
                            mostrarBotaoCancelar
                            aoClicarCancelar={() => {
                              setflag_gerir_caderno(false);
                              setflag_escolha_caderno_manual(false);
                              setflag_escolha_carregar_candidatura(false);
                              set_flag_criar_caderno_de_ano_anterior(false)

                            }}
                          />
                        </div>

                        <div style={{
                          // backgroundColor: 'red',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexDirection: 'column',
                          alignSelf: 'center',
                          height: '100%',
                          width: '100%',

                        }}>

                          <div
                            style={{
                              // backgroundColor: cores.cor1,
                              display: "flex",
                              alignItems: 'center',
                              justifyContent: 'center',
                              flex: 0.1,
                              fontWeight: 'bold',
                              // color: 'white',
                              fontSize: 25,
                              width: '100%',
                              fontFamily: "candara"
                            }}>

                            Criação de Caderno


                          </div>
                          {flag_escolha_caderno_manual === false &&
                            flag_escolha_carregar_candidatura === false &&
                            flag_criar_caderno_de_ano_anterior === false ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                paddingBottom: 50,
                                paddingTop: 30,
                              }}
                            >

                              <Button
                                size="large"
                                sx={{
                                  width: 250,
                                  marginBottom: 5,
                                  backgroundColor: cores.cor1,
                                  color: "#ffffff",
                                  "&:hover": {
                                    backgroundColor: "transparent",
                                    color: "#7e2706",
                                  },
                                  fontFamily: "candara",
                                }}
                                onClick={() =>
                                  setflag_escolha_carregar_candidatura(true)
                                }
                              >
                                Carregar Candidatura
                              </Button>
                              <Button
                                size="large"
                                sx={{
                                  width: 250,
                                  marginBottom: 5,

                                  backgroundColor: "#c94f1e",
                                  color: "#ffffff",
                                  "&:hover": {
                                    backgroundColor: "transparent",
                                    color: "#7e2706",
                                  },
                                  fontFamily: "candara",
                                }}
                                onClick={() =>
                                  setflag_escolha_caderno_manual(true)
                                }
                              >
                                Criar Caderno Manualmente
                              </Button>

                              <Button
                                size="large"
                                sx={{
                                  width: 250,

                                  backgroundColor: "#c94f1e",
                                  color: "#ffffff",
                                  "&:hover": {
                                    backgroundColor: "transparent",
                                    color: "#7e2706",
                                  },
                                  fontFamily: "candara",
                                }}
                                onClick={() =>
                                  set_flag_criar_caderno_de_ano_anterior(true)
                                }
                              >
                                Replicar Caderno de Ano Anterior
                              </Button>
                            </div>
                          ) : flag_escolha_caderno_manual === true ? (
                            <DialogNovoCadernoManual
                              handleCreateCaderno_arg={() => handleCreateCaderno()}
                              setDrapChoose_arg={(choose_drap: string) => { setDrapChoose(choose_drap); }}
                              setValueYear_arg={(obj: Dayjs | null) => setValueYear(obj)}
                              set_obj_template_escolhido_arg={(obj) => set_obj_template_escolhido(obj)}
                              set_cor_aux={set_cor}
                              set_cultura_aux={set_cultura}
                            />
                          ) : flag_escolha_carregar_candidatura === true ? (
                            <Box
                              sx={{ marginTop: 10 }}
                              padding={2}
                              width="100%"
                              display="flex"
                              alignItems="center"
                              component={Paper}
                              justifyContent="center"
                            >
                              <Stack>
                                <Typography
                                  fontFamily="candara"
                                  align="center"
                                  padding={2}
                                >
                                  Carregar candidatura
                                </Typography>
                                {isloading ? (
                                  <LoadingVulpesSmall />
                                ) : (
                                  <>
                                    <form onSubmit={(e) => e.preventDefault()}>
                                      <Button
                                        variant="contained"
                                        component="label"
                                        size="small"
                                        sx={{
                                          fontFamily: "candara",
                                          backgroundColor: "#ccafa3",
                                          "&:hover": {
                                            backgroundColor: "#f2d1c2",
                                            color: "#000000",
                                          },
                                        }}
                                      >
                                        <input
                                          style={{
                                            color: "#7e2706",
                                            fontFamily: "candara",
                                          }}
                                          accept=".pdf"
                                          type="file"
                                          onChange={onChange} />
                                      </Button>

                                    </form><Stack direction="row" display="flex" justifyContent="end" paddingTop={5}>
                                      <BarraDeFerramentas
                                        mostrarBotaoNovo
                                        aoClicarNovo={() => novoCaderno()}
                                        textoBotaoNovo="CRIAR" />
                                    </Stack>
                                  </>
                                )}
                              </Stack>
                            </Box>
                          ) : flag_criar_caderno_de_ano_anterior === true ?
                            <DialogReplicarCadernoDeAnoAnterior
                              handle_replicar_caderno_de_ano_anterior={() => handle_replicar_caderno_de_ano_anterior()}
                              set_ano_novo_caderno={(obj: Dayjs | null) => set_ano_novo_caderno(obj)}
                              set_id_caderno_a_replicar={(obj: string) => set_id_caderno_a_replicar(obj)}
                              set_id_rosto_a_replicar={(obj: string) => set_id_rosto_a_replicar(obj)}
                              id_agri={beneficiario?.id_agri}
                              setIsLoading={(flag: boolean) => { setIsLoading(flag) }}

                            />
                            :
                            (
                              <DialogNovoCadernoManual
                                handleCreateCaderno_arg={() => handleCreateCaderno()}
                                setDrapChoose_arg={(choose_drap: string) => { setDrapChoose(choose_drap); }}
                                setValueYear_arg={(obj: Dayjs | null) => setValueYear(obj)}
                                set_obj_template_escolhido_arg={(obj) => set_obj_template_escolhido(obj)}
                                set_cor_aux={set_cor}
                                set_cultura_aux={set_cultura}
                              />
                            )}
                        </div>
                      </div>

                      {/* </div> */}
                    </Modal>
                  ) : (
                    <></>
                  )}

                  {/************ CRIAR CADERNO EFICIENCIA **************/}
                  {flag_gerir_eficiencia ?
                    <Dialog
                      open={flag_gerir_eficiencia}
                      onClose={() => setflag_gerir_eficiencia(false)}
                      maxWidth="lg"
                      sx={{ padding: 10 }}
                    >
                      <div style={{ marginLeft: "auto" }}>
                        <BarraDeFerramentas
                          mostrarBotaoCancelar
                          aoClicarCancelar={() => { setflag_gerir_eficiencia(false); }}
                        />
                      </div>
                      <DialogTitle
                        fontFamily="candara" fontSize={22} fontWeight={500}
                      >
                        Criação de Eficiência alimentar
                      </DialogTitle>
                      <DialogContent>
                        <DialogNovaEficienciaAlimentar
                          id_agri={id_agri_eficiencia}
                          setflag_gerir_eficiencia={setflag_gerir_eficiencia}
                          setIsLoading={setIsLoading}

                        />
                      </DialogContent>
                    </Dialog> :
                    <></>}

                </TableContainer>
              </div>

              {/********** DIV LADO DIREITO ******************/}
              {openInfoAboutBeneficiario ? (
                <div
                  id="dados"
                  style={{
                    flex: 0.6,
                    paddingLeft: 10,

                    height: "75vh",
                    display: "flex",
                  }}
                >
                  <TableContainer
                    component={Paper}
                    variant="outlined"
                    sx={{ height: "auto", width: "100%" }}
                  >
                    <Box sx={{ width: "100%" }}>
                      <Tabs
                        value={valueTab}
                        variant="fullWidth"
                        onChange={handleChangeTabNavigation}
                        className={classes.tabs}
                      >
                        <Tab
                          value="1"
                          label="Histórico"
                          sx={{
                            fontWeight: 700,
                            fontFamily: "candara",
                            fontSize: 18,
                          }}
                        />
                        <Tab
                          value="2"
                          label="Listagem Parcelas"
                          sx={{
                            fontWeight: 700,
                            fontFamily: "candara",
                            fontSize: 18,
                          }}
                        />
                      </Tabs>
                    </Box>

                    <TableContainer
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        alignContent: "center",
                      }}
                    >
                      <table width="90%">
                        {valueTab === "1" ? (
                          <Historico
                            idagri={beneficiario?.id_agri}
                            idrosto={obj_caderno?.id_rosto}
                            nome={beneficiario?.nome}
                            nif={beneficiario?.nif}


                          />
                        ) : (
                          <TableBody>
                            <TableRow>
                              <StyledTableHeadWithoutBorder colSpan={5}
                                sx={{

                                  // minWidth:'100%'
                                }}
                              >
                                <div
                                  style={{
                                    flex: 1,
                                    flexDirection: 'row',
                                    justifyContent: 'flex-start',
                                    alignItems: "center",
                                    display: 'flex',
                                  }}
                                >

                                  <BarraDeFerramentas
                                    mostrarBotaoNovo
                                    textoBotaoNovo="Adicionar Parcela"
                                    aoClicarNovo={() => {
                                      set_flag_nova_parcela(true)

                                      set_open_modal_criar_parcela(true)
                                    }}

                                  />
                                  <div style={{
                                    paddingLeft: '2%'
                                  }}>
                                    <BarraDeFerramentas
                                      mostrarBotaoUpload
                                      textoBotaoUpload="Upload Ficheiro IE"
                                      aoClicarUpload={() => setuploadIE_from_parcelas(true)}
                                    />
                                  </div>
                                  <div style={{
                                    paddingLeft: '2%'
                                  }}>
                                    <BarraDeFerramentas
                                      mostrarBotaoApagarComIcon
                                      textoBotaoApagar={flag_eliminar_varias_parcelas ? 'Eliminar Items Selecionados' : "Eliminar Vários"}
                                      aoClicarApagar={() => {

                                        if (flag_eliminar_varias_parcelas) {

                                          set_open_dialog_tem_a_certeza_que_quer_eliminar_parcelas_selecionadas(true)


                                        } else {
                                          set_flag_eliminar_varias_parcelas(true)

                                        }

                                      }}
                                    />
                                  </div>
                                </div>

                              </StyledTableHeadWithoutBorder>
                            </TableRow>
                            <TableRow>
                              <StyledTableHeadWithoutBorder>
                                Nº Sequência
                              </StyledTableHeadWithoutBorder>
                              <StyledTableHeadWithoutBorder>
                                Nº Parcelário
                              </StyledTableHeadWithoutBorder>
                              <StyledTableHeadWithoutBorder>
                                Nome da Parcela
                              </StyledTableHeadWithoutBorder>
                              <StyledTableHeadWithoutBorder>
                                Área (ha)
                              </StyledTableHeadWithoutBorder>
                              <StyledTableHeadWithoutBorder>
                                IQFP
                              </StyledTableHeadWithoutBorder>
                              <StyledTableHeadWithoutBorder>
                                Ações
                              </StyledTableHeadWithoutBorder>
                            </TableRow>

                            {listaParcelas === undefined ? (
                              <TableRow key={0}>
                                <StyledTableCellWithoutBorder>
                                  {aviso_sem_info()}
                                </StyledTableCellWithoutBorder>
                                <StyledTableCellWithoutBorder>
                                  {aviso_sem_info()}
                                </StyledTableCellWithoutBorder>
                                <StyledTableCellWithoutBorder>
                                  {aviso_sem_info()}
                                </StyledTableCellWithoutBorder>
                                <StyledTableCellWithoutBorder>
                                  {aviso_sem_info()}
                                </StyledTableCellWithoutBorder>
                                <StyledTableCellWithoutBorder>
                                  {aviso_sem_info()}
                                </StyledTableCellWithoutBorder>
                                <StyledTableCellWithoutBorder>
                                </StyledTableCellWithoutBorder>
                              </TableRow>
                            ) : (
                              listaParcelas.map((lista) => (
                                <TableRow key={lista.id_parcela}>
                                  <StyledTableCellWithoutBorder>
                                    {lista.numero_seq}
                                  </StyledTableCellWithoutBorder>
                                  <StyledTableCellWithoutBorder>
                                    {lista.numero_Parce}
                                  </StyledTableCellWithoutBorder>
                                  <StyledTableCellWithoutBorder>
                                    {lista.nome}
                                  </StyledTableCellWithoutBorder>
                                  <StyledTableCellWithoutBorder>
                                    {lista.area_gis}
                                  </StyledTableCellWithoutBorder>
                                  <StyledTableCellWithoutBorder>
                                    {lista.iqfp}
                                  </StyledTableCellWithoutBorder>
                                  {
                                    flag_eliminar_varias_parcelas ?

                                      <StyledTableCellWithoutBorder>
                                        <div style={{
                                          display: 'flex',
                                          flexDirection: 'row',
                                          alignItems: 'center',
                                          justifyContent: 'center'
                                        }}>
                                          <Checkbox
                                            sx={{
                                              color: "#aaaaaa",
                                              "&.Mui-checked": {
                                                color: "#C94F1E",
                                                fontFamily: "candara",
                                              },
                                            }}
                                            checked={listaParcelas_a_eliminar.includes(lista)}
                                            onChange={() => {

                                              if (listaParcelas_a_eliminar.includes(lista)) {
                                                let aux_lista = listaParcelas_a_eliminar.filter((el) => {
                                                  if (el.id_parcela !== lista.id_parcela) {
                                                    return el
                                                  }
                                                })
                                                setlistaParcelas_a_eliminar(aux_lista)
                                              } else if (listaParcelas_a_eliminar.length === 0) {
                                                setlistaParcelas_a_eliminar([lista])

                                              } else {
                                                setlistaParcelas_a_eliminar((old) => [...old, lista])

                                              }
                                            }}
                                          />

                                        </div>
                                      </StyledTableCellWithoutBorder>
                                      :


                                      <StyledTableCellWithoutBorder>
                                        <div style={{
                                          display: 'flex',
                                          flexDirection: 'row',
                                          alignItems: 'center',
                                          justifyContent: 'center'
                                        }}>
                                          <IconButton
                                            sx={{
                                              color: "#7e2706",
                                              "&:hover": {
                                                backgroundColor: "transparent",
                                                color: "#fd0f04",
                                              },
                                            }}
                                            size="small"
                                            onClick={() => {

                                              set_flag_nova_parcela(false)
                                              set_open_modal_criar_parcela(true)
                                              set_id_parcela_editar(lista.id_parcela)
                                              set_nome_parcela(lista.nome)
                                              set_n_sequencia(lista.numero_seq === null ? '' : lista.numero_seq.toString())
                                              set_area_parcela(lista.area_gis === null ? '' : lista.area_gis.toString())
                                              set_n_parcelario(lista.numero_Parce)
                                              set_iqfp(lista.iqfp === null ? '' : lista.iqfp.toString())
                                            }}
                                          >
                                            <EditIcon />
                                          </IconButton>
                                          <IconButton
                                            sx={{
                                              color: "#7e2706",
                                              "&:hover": {
                                                backgroundColor: "transparent",
                                                color: "#fd0f04",
                                              },
                                            }}
                                            size="small"
                                            onClick={async () => {
                                              set_parcela_para_ver_subparcelas(lista)

                                              set_open_modal_ver_subparcelas(true)

                                              await get_subparcelas_by_parcela(lista.id_parcela, lista.numero_seq)

                                            }}
                                          >
                                            <Search />
                                          </IconButton>
                                          <ButtonCadernos

                                            mostrarBotaoApagar
                                            aoClicarApagar={() => {
                                              set_id_parcela_editar(lista.id_parcela)

                                              set_open_dialog_tem_a_certeza_que_quer_eliminar_parcela(true)
                                            }}
                                          />
                                        </div>
                                      </StyledTableCellWithoutBorder>
                                  }

                                </TableRow>
                              ))
                            )}
                            <TableRow>
                              <StyledTableCellWithoutBorder
                                colSpan={4}
                                sx={{
                                  fontFamily: "candara",
                                  fontSize: 20,
                                  color: "#7e2706",
                                }}
                              >
                                Total de Parcelas
                              </StyledTableCellWithoutBorder>
                              <StyledTableCellWithoutBorder
                                sx={{
                                  fontFamily: "candara",
                                  fontSize: 22,
                                  color: "#7e2706",
                                }}
                              >
                                {listaParcelas === undefined
                                  ? 0
                                  : listaParcelas.length}
                              </StyledTableCellWithoutBorder>
                            </TableRow>
                          </TableBody>
                        )}
                      </table>
                    </TableContainer>
                  </TableContainer>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </main>
      </div>
    </CustomThemeProvider>
  );
}
export default Home;
